import { useCallback, useEffect, useState, useRef, useMemo, createRef } from 'react';
import styles from './AssignedDriver.module.css';
import { TextField, Button, Tooltip, Breadcrumbs, Typography } from '@mui/material';
import DataTable from 'react-data-table-component';
import { X, ArrowRight, Printer, Plus, Edit } from 'react-feather';
import axios from 'axios';
import { TableLoader } from '../../components/LoaderC';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import AssignPopup from "./AssignPopup";
import withAdminAuth from "../../components/withAdminAuth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { ComponentToPrint } from './AssignedDriverPrint';
import { ComponentToPrintList } from './AssignedDriverPrintList';
import { useReactToPrint } from 'react-to-print';
import NotePopup from './NotePopup';
import PaymentPopup from '../bookings/PaymentPopup';

const customDataTableStyles = {
  head: {
    style: {
      zIndex: 0
    },
  },
  headCells: {
    style: {
      backgroundColor: '#1e1e2d',
      color: '#fff'
    },
  },
}

const DataTableWithExport = ({ columns, data, customStyles, onSelectedRowsChange, rowDisabledCriteria, selectedRows2 }) => {
  const componentRef = useRef();
  const componentRef2 = useRef();

  const [printData, setPrintData] = useState([]);

  const Export = ({ onExport }) => <Button onClick={e => onExport(e.target.value)} className="TableAddBU" style={{ width: 'auto' }}>Export To CSV</Button>;

  const convertArrayOfObjectsToCSV = (array) => {
    let result;

    const columnDelimiter = ',';
    const lineDelimiter = '\n';
    const keys = ['driver_name', 'booking_id', 'address', 'contact_no', 'recepient_name', 'order_status', 'delivery_notes', 'assigned_date'];

    result = '';
    //result += keys.join(columnDelimiter);
    keys.forEach(key => {
      if (key === 'driver_name') {
        result += 'Driver Name';
      } else if (key === 'booking_id') {
        result += 'Booking Id';
      } else if (key === 'address') {
        result += 'Address';
      } else if (key === 'contact_no') {
        result += 'Contact No';
      } else if (key === 'recepient_name') {
        result += 'Recepient Name';
      } else if (key === 'order_status') {
        result += 'Order Status';
      } else if (key === 'delivery_notes') {
        result += 'Delivery Notes';
      } else if (key === 'assigned_date') {
        result += 'Assigned Date';
      } else {
        result += key;
      }
      result += columnDelimiter;
    });
    result += lineDelimiter;

    array.forEach(item => {
      let ctr = 0;
      keys.forEach(key => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  const downloadCSV = useCallback(() => {
    let newArray = data.map(row => {
      return { 'driver_name': row?.delivery_driver?.name, 'booking_id': row?.reference_id, 'address': row?.dropoff_details?.address.replace(/,/g, ""), 'contact_no': row?.dropoff_details?.phone, 'recepient_name': row?.dropoff_details?.name, 'order_status': ((row?.payment_status === 1 || row?.payment_status === '1') ? 'Paid' : 'Unpaid'), 'delivery_notes': row?.delivery_note, 'assigned_date': moment(row?.delivery_driver?.updated_at).format('DD/MM/YYYY') }
    });

    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(newArray);
    if (csv == null) return;

    const filename = 'driver-jobs.csv';

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }
    link.setAttribute('href', encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();
  }, [data]);


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrint22 = useReactToPrint({
    content: () => componentRef2.current,
  });

  useEffect(() => {
    let printDataTemp = data?.filter(i => selectedRows2.indexOf(i?.id) > -1);
    setPrintData(printDataTemp);
  }, [selectedRows2, data]);

  const handlePrint2 = useCallback(() => {
    if (selectedRows2.length === 0) {
      toast.error('Please select item(s)', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "light",
      });

      return false;
    }

    handlePrint22();
  }, [selectedRows2, handlePrint22]);

  const actionsMemo = useMemo(() => <><Export onExport={() => downloadCSV()} /><Button onClick={handlePrint} className="TableAddBU" style={{ width: 'auto' }}>Print Bookings</Button><Button onClick={() => handlePrint2()} className="TableAddBU" style={{ width: 'auto' }}>Print Driver Jobs</Button></>, [downloadCSV, handlePrint, handlePrint2]);

  return <>
    <div style={{ display: "none" }}>
      <ComponentToPrintList ref={componentRef} data={data} />
    </div>
    <div style={{ display: "none" }}>
      <ComponentToPrint ref={componentRef2} bookingData={printData} />
    </div>
    <DataTable
      className='DataTable'
      columns={columns}
      data={data}
      pagination
      customStyles={customStyles}
      selectableRows
      selectableRowDisabled={rowDisabledCriteria}
      onSelectedRowsChange={onSelectedRowsChange.bind(this)}
      actions={actionsMemo}
      noContextMenu={true}
    />
  </>
}

const BookingList = ({ history, match }) => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [assignModalShow, setAssignModalShow] = useState(false);
  const [noteModalShow, setNoteModalShow] = useState(false);
  const [paymentModalShow, setPaymentModalShow] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [currentItem, setCurrentItem] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRows2, setSelectedRows2] = useState([]);
  const [editNote, setEditNote] = useState(null);
  const componentRef = useRef([]);

  const columns = [{
    name: 'Driver Name',
    selector: row => row?.delivery_driver?.name,
    sortable: true,
  }, {
    name: 'Booking Id',
    selector: row => row?.reference_id,
    sortable: true,
  }, {
    name: 'Address',
    selector: row => row?.dropoff_details?.address,
    sortable: true,
  }, {
    name: 'Contact No',
    selector: row => row?.dropoff_details?.phone,
    sortable: true,
  }, {
    name: 'Recepient Name',
    selector: row => row?.dropoff_details?.name,
    sortable: true,
  }, {
    name: 'Order Status',
    selector: tableProps => (<>
      {((tableProps?.payment_status === 1 || tableProps?.payment_status === '1') ? <Button className={`${styles.StatusBU} ${styles.DisaBU}`}>Paid</Button> : <Button className={`${styles.StatusBU}`} onClick={(e) => { setPaymentModalShow(true); setCurrentItem([tableProps?.id]); }}>Unpaid</Button>)}
    </>),
    sortable: true,
  }, {
    name: 'Delivery Notes',
    selector: row => ((row?.delivery_note && row?.delivery_note !== '') ? <><div style={{ marginRight: '25px' }}>{row?.delivery_note}</div><div style={{ position: 'absolute', right: '3px', top: '5px' }}><Button className={`${styles.StatusBU2}`} onClick={(e) => { setNoteModalShow(true); setCurrentItem(row?.id); setEditNote(row?.delivery_note); }}><Edit /></Button></div></> : <Button className={`${styles.StatusBU}`} onClick={(e) => { setNoteModalShow(true); setCurrentItem(row?.id); setEditNote(null); }}>Add Note</Button>),
    sortable: true,
  }, {
    name: 'Assigned Date',
    selector: row => moment(row?.delivery_driver?.delivered_date).format('DD/MM/YYYY'),
    sortable: true
  }, {
    name: 'Action',
    cell: (tableProps, index) => (
      <div className={`${styles.ActionDiv}`}>
        <div style={{ display: "none" }}><ComponentToPrint ref={componentRef.current[index]} bookingData={[tableProps]} /></div>
        <ReactToPrint content={() => componentRef.current[index]?.current}>
          <PrintContextConsumer>
            {({ handlePrint }) => (<Button onClick={handlePrint}><Printer /></Button>)}
          </PrintContextConsumer>
        </ReactToPrint>
        <Tooltip title="Re-assign or un-assign" onClick={(e) => { setAssignModalShow(true); setSelectedRows([tableProps?.id]); }}><Button><ArrowRight /></Button></Tooltip>
      </div>),
    sortable: false
  }];

  useEffect(() => {
    const fetchUsers = () => {
      axios(process.env.REACT_APP_API_URL + 'v1/delivery/assigned-bookings', {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then(response => {
        setContentLoading(false);
        if (response.data.status === 'SUCCESS') {
          setAllData(response.data.data);

          response.data.data.forEach((element, index) => {
            componentRef[index] = createRef();
          });
        }
      }).catch(error => {
        setContentLoading(false);
      });
    }

    fetchUsers();
  }, [auth?.api_token]);

  useEffect(() => {
    let filteredData = allData;

    if (filterText !== '') {
      let inputVal = filterText;
      inputVal = inputVal.toLowerCase();
      filteredData = filteredData.filter((item) => {
        return item?.delivery_driver?.name.toLowerCase().includes(inputVal) || item?.reference_id.toLowerCase().includes(inputVal) || item?.dropoff_details?.address.toLowerCase().includes(inputVal) || item?.dropoff_details?.phone.toLowerCase().includes(inputVal) || item?.dropoff_details?.name.toLowerCase().includes(inputVal);
      });
    }

    setData(filteredData);
  }, [allData, filterText]);

  const makeDelivered = () => {
    if (selectedRows2.length === 0) {
      toast.error('Please select item(s)', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "light",
      });

      return false;
    }

    setLoading(true);

    let postData = { bookingIds: selectedRows2 };

    axios.post(process.env.REACT_APP_API_URL + 'v1/delivery/make-as-delivered', postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {

        axios(process.env.REACT_APP_API_URL + 'v1/delivery/assigned-bookings', {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then(response => {
          setLoading(false);
          if (response.data.status === 'SUCCESS') {
            setAllData(response.data.data);
          }
        }).catch(error => {
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  const rowDisabledCriteria = (e) => {
    return parseInt(e?.payment_status) !== 1;
  }

  const handleChange2 = ({ selectedRows }) => {
    let selectedRowTemp = selectedRows.map(item => {
      return item.id;
    });
    setSelectedRows2(selectedRowTemp);
  }

  const assignDriver = (message) => {
    toast.success(message, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "light",
    });

    axios(process.env.REACT_APP_API_URL + 'v1/delivery/assigned-bookings', {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        setAllData(response.data.data);
      }
    }).catch(error => { });
  }

  const noteItemAdd = (message, item) => {
    toast.success(message);

    setAllData(prev => {
      return prev.map(i => {
        if (i.id === item?.id)
          return { ...i, delivery_note: item?.delivery_note }
        return i;
      });
    })
  }

  const paymentItem = (message, id) => {
    toast.success(message);

    setAllData(prev => {
      return prev.map(i => {
        if (i.id === id)
          return { ...i, payment_status: 1 }
        return i;
      });
    })
  }

  return (<>
    {loading && <Loader />}
    {contentLoading && <div className="LoaderCard"><div className="Loader TableLoader"><TableLoader /></div></div>}
    {!contentLoading && <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>View Driver Job For Delivery</p>
        <Breadcrumbs aria-label="breadcrumb" className='breadcrumb'>
          <Typography color="text.primary">Ghana Delvery</Typography>
          <Typography color="text.primary">Driver Job</Typography>
        </Breadcrumbs>
      </div>
      <div className={`${styles.MainCard}`}>
        <div className='TableFilterHead'>
          <div className="DataTableSearch">
            <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={filterText} onChange={(e) => setFilterText(e.target.value)} autoComplete='off' />
            {filterText !== '' && <Button type="button" className="CloseBU" onClick={(e) => setFilterText('')}><X /></Button>}
          </div>
          <div className='TableFilterBUSec'>
            <Button className="TableAddBU" onClick={(e) => makeDelivered()}><Plus /> Delivered</Button>
          </div>
        </div>

        <div className='TableContent'>
          <DataTableWithExport columns={columns} data={data} customStyles={customDataTableStyles} rowDisabledCriteria={rowDisabledCriteria.bind(this)} onSelectedRowsChange={handleChange2.bind(this)} selectedRows2={selectedRows2} />
        </div>
      </div>
    </div>}

    <Modal show={assignModalShow} onHide={(e) => setAssignModalShow(false)} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Assign Booking Details To Driver</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AssignPopup onSubmit={assignDriver.bind(this)} selectedRows={selectedRows} setModalShow={setAssignModalShow.bind(this)} setLoading={setLoading.bind(this)} />
      </Modal.Body>
    </Modal>

    <Modal show={noteModalShow} onHide={(e) => setNoteModalShow(false)} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>{editNote ? 'Edit Note' : 'Add Note'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NotePopup setModalShow={setNoteModalShow.bind(this)} noteItem={noteItemAdd.bind(this)} bookingId={currentItem} editNote={editNote} setLoading={setLoading.bind(this)} />
      </Modal.Body>
    </Modal>

    <Modal show={paymentModalShow} onHide={(e) => setPaymentModalShow(false)} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PaymentPopup setModalShow={setPaymentModalShow.bind(this)} paymentItem={paymentItem.bind(this)} bookingId={currentItem} setCurrentItem={setCurrentItem.bind(this)} setLoading={setLoading.bind(this)} />
      </Modal.Body>
    </Modal>
  </>);
}

export default withAdminAuth(BookingList);